module.exports = __webpack_public_path__ + "img/bosniaandherzegovina.def0964a.svg";